import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import axios from "axios";
const root = ReactDOM.createRoot(document.getElementById("root"));
let getConfig = async () => {
  let result = await axios({
    method: "get",
    url: "/api/getconfig",
  });
  return result.data;
};

getConfig().then(function (configObject) {
  root.render(
    <App
      glassboxReportingURL={configObject.glassbox.reportingUrl}
      analyticsConfig={{
        identityPoolId: configObject.analytics.idpId,
        region: configObject.analytics.region,
        streamName: configObject.analytics.streamName,
      }}
    />
  );
});
